export enum EXTENSION_ACTIONS {
  ping = 'ping',
  login = 'login',
  logout = 'logout',
  redirect = 'redirect',
  redirectReady = 'redirectReady',
  toggleIframe = 'toggleIframe',
  clickGmail = 'clickGmail',
  openOnFoamAssist = 'openOnFoamAssist',
  refreshWatchlist = 'refreshWatchlist',
}

export const CONV_STARTER_ACTION_TYPES = {
  prep1on1Chat: 'prep1on1Chat',
  mentionedBrandsChat: 'mentionedBrandsChat',
  draftEmailPitchChat: 'draftEmailPitchChat',
} as const;

export const ONBOARDING_HOOKS_ACTION_TYPES = {
  viewSimilarPostsHook: 'viewSimilarPostsHook',
  analyzeContentHook: 'analyzeContentHook',
  avgViewsCustomHook: 'avgViewsCustomHook',
  mentionedBrandsHook: 'mentionedBrandsHook',
  prep1on1Hook: 'prep1on1Hook',
  recommendedBrandPartnersHook: 'recommendedBrandPartnersHook',
  enhanceSearchHook: 'enhanceSearchHook',
} as const;

export const ONBOARDING_HOOKS_TRACK_ID = {
  recommendedBrandPartners:
    'foam-onboarding-hooks-recommended-brand-partners-button',
} as const;

export const FOAM_ASSIST_CHROME_STORE_URL =
  'https://chromewebstore.google.com/detail/foam-the-essential-chrome/iocblckedogkccdepdjfceomgncpeadf';

export const CONVERSATION_STARTERS_OPEN_SIDEPANEL_DELAY = 300;

/** Content script → web app `postMessage` (`data.action`), same family as `foam_ce-embedCopied`. */
export const FOAM_CE_WEB_MESSAGE_ACTION = {
  refreshWatchlist: 'foam_ce-refreshWatchlist',
} as const;
